/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toMoment = _interopRequireDefault(require("../toMoment"));
var CONFIG = {
  dayFormat: 'D',
  monthFormat: 'MMMM',
  yearFormat: 'YYYY'
};
var f = function f(mom, format) {
  return (0, _toMoment.default)(mom).format(format);
};
var _default = {
  day: function day(mom, format) {
    return f(mom, format || CONFIG.dayFormat);
  },
  month: function month(mom, format) {
    return f(mom, format || CONFIG.monthFormat);
  },
  year: function year(mom, format) {
    return f(mom, format || CONFIG.yearFormat);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/utils/format.js
// module id = 640
// module chunks = 0